import { Dialog as SheetPrimitive } from '@base-ui/react/dialog';

export type SheetPortalProps = SheetPrimitive.Portal.Props;

const SheetPortal = ({ ...props }: SheetPortalProps) => {
  return <SheetPrimitive.Portal data-slot="sheet-portal" {...props} />;
};

export default SheetPortal;
